<picture>
  <source [srcset]="src | webpUrl" type="image/webp">
  <img
    [src]="src"
    [alt]="alt"
    [title]="title"
    [ngStyle]="imgStyle"
    [ngClass]="imgClass"
    loading="lazy">
</picture>
